import { Component, OnInit } from '@angular/core';
import { NotificationService } from './core/services/notification.service';
import { NavigationEnd, Router } from '@angular/router';
// import * as mixpanel from 'mixpanel-browser';
import mixpanel from 'mixpanel-browser';
import { filter } from 'rxjs/operators';

declare module 'mixpanel-browser';

declare var gtag : any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'value-driver-website';
  status = false as boolean;
  message = "" as string;
  constructor(
    private notification : NotificationService,
    private router : Router

  ){
    mixpanel.init('f66bc11aacfaca02245efb64c6fff482', { debug: true });
    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe((event: NavigationEnd) => {
    //     this.trackPageView(event.urlAfterRedirects);
    //   });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Send pageview event to Google Analytics
        this.trackPageView(event.urlAfterRedirects)
        gtag('config', 'G-9G4RJ9KMHE', {
          'page_path': event.urlAfterRedirects
        });
      }
    });
  }

  trackPageView(url: string) {
    mixpanel.track('Page Viewed', {
      page: url
    });
  }
  

  ngOnInit(): void {
      this.notification.showLoader.subscribe((res)=> {
        this.status = res.show
        this.message = res.message
      })

      
  }
}
